import { create } from 'zustand';

interface PlaylistSelectionState {
  selectedIds: Set<string>;
  selectedGroupIds: Set<string>;
  activePlaylistId: string | null;
  toggleSelected: (id: string, isGroup?: boolean) => void;
  selectAll: (ids: string[], groupIds?: string[]) => void;
  clearSelection: () => void;
  isSelected: (id: string) => boolean;
  selectedCount: () => number;
  getPlaylistIds: () => string[];
  getGroupIds: () => string[];
  setActivePlaylist: (id: string | null) => void;
}

export const usePlaylistSelectionStore = create<PlaylistSelectionState>((set, get) => ({
  selectedIds: new Set(),
  selectedGroupIds: new Set(),
  activePlaylistId: null,
  toggleSelected: (id, isGroup) =>
    set((state) => {
      const nextIds = new Set(state.selectedIds);
      const nextGroupIds = new Set(state.selectedGroupIds);
      if (nextIds.has(id)) {
        nextIds.delete(id);
        nextGroupIds.delete(id);
      } else {
        nextIds.add(id);
        if (isGroup) nextGroupIds.add(id);
      }
      return { selectedIds: nextIds, selectedGroupIds: nextGroupIds };
    }),
  selectAll: (ids, groupIds) =>
    set({
      selectedIds: new Set(ids),
      selectedGroupIds: new Set(groupIds ?? []),
    }),
  clearSelection: () => set({ selectedIds: new Set(), selectedGroupIds: new Set() }),
  isSelected: (id) => get().selectedIds.has(id),
  selectedCount: () => get().selectedIds.size,
  getPlaylistIds: () => {
    const { selectedIds, selectedGroupIds } = get();
    return Array.from(selectedIds).filter((id) => !selectedGroupIds.has(id));
  },
  getGroupIds: () => Array.from(get().selectedGroupIds),
  setActivePlaylist: (id) => set({ activePlaylistId: id }),
}));
